/**
 * weishi share module
 * @module
 * @example
 * WSShare.h5share.saiyan({});
 * @tutorial http://tnpm.oa.com/package/@tencent/h5-share
 */
import h5share from './h5-share';

export default {
  h5share,
};
